/*eslint-disable*/
import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// core components
import Header from "components/Header/Header.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import mccannVid from "../../../assets/img/bgVid.mp4";
import loginPageStyle from "../../../assets/jss/CustomerTradePortal/views/logInStyle.js";
import bgImage from "../../../assets/img/cadebyDepot.jpg";
import LoginClass from '../LogInPage/Classes/LogInClass.js';
import mcCannLogo from 'assets/img/fpmccann white.png';
import LoadingData from '../lottieLoading';
import { useDispatch, useSelector } from "react-redux";
const useStyles = makeStyles(loginPageStyle);

export default function LoginPage() {
    React.useEffect(() => {
        window.scrollTo(0, 0);
        document.body.scrollTop = 0;
    });

    const authenticatingUserLoading = useSelector(state => state.userReducer.loadingPage);

    const classes = useStyles();


    if (!authenticatingUserLoading) {
        return (
            <div>
                <Header
                    brand={
                        <div style={{ textAlign: "center" }}>

                            <img
                                src={mcCannLogo}
                                height={50}
                                width={75}
                                alt="FPMcCannLogo"
                            />
                            {' '}
                            {/*            <b> Easi-Order Portal</b>*/}

                        </div>}
                    links={<HeaderLinks dropdownHoverColor="info" />}
                    fixed
                    color="transparent"
                    changeColorOnScroll={{
                        height: 50,
                        color: "info",

                    }}>
                </Header>

                <div className={classes.pageHeader} style={{
                    backgroundSize: "cover",
                    backgroundPosition: "top center",
                }}>

                    <video autoPlay playsInline loop muted poster={bgImage} className={classes.video}>
                        <source src={mccannVid} type='video/mp4' />
                        <source src={mccannVid} type="video/ogg" />
                    </video>

                    <div className={classes.container}>
                        <GridContainer justify="center">
                            <GridItem xs={12} sm={12} md={8}>
                                <Card>
                                    <form className={classes.form}>
                                        <CardHeader
                                            color="info"
                                            signup
                                            className={classes.cardHeader}
                                        >
                                            <div style={{ textAlign: "center" }}>
                                                <img
                                                    src={mcCannLogo}
                                                    height={45}
                                                    width={65}
                                                    alt="FPMcCannLogo"
                                                />
                                                {' '}

                                            </div>
                                            <h3 className={classes.cardTitle}>Customer Log in</h3>
                                            <div className={classes.socialLine}>
                                                <Button
                                                    justIcon
                                                    color="transparent"
                                                    className={classes.iconButtons}
                                                >
                                                    <i className="fab fa-twitter" />
                                                </Button>
                                                <Button
                                                    justIcon
                                                    color="transparent"
                                                    className={classes.iconButtons}
                                                >
                                                    <i className="fab fa-facebook" />
                                                </Button>
                                                <Button
                                                    justIcon
                                                    color="transparent"
                                                    className={classes.iconButtons}
                                                >
                                                    <i className="fab fa-google-plus-g" />
                                                </Button>
                                            </div>
                                        </CardHeader>


                                        <GridContainer style={{
                                            backgroundSize: "cover",
                                            padding: "20px",
                                        }}>

                                            <GridItem xs={12} sm={6} md={6}>
                                                <h4 className={classes.title}>
                                                    <b> Easi-Order Portal</b></h4>
                                                <p>
                                                    Introducing the FP McCann Easi-Order, your comprehensive online portal for ordering building supplies anytime throughout the year.
                                                    With Easi-Order, you can easily purchase various products, including fencing, drainage systems, roof tiles, bagged products, and more.
                                                    Our system processes your orders instantly, allowing you immediate access to track and manage your purchases whenever needed.
                                                    Enjoy the convenience of ordering 24/7, 365 days a year!
                                                </p>
                                            </GridItem>

                                            <GridItem xs={12} sm={6} md={6}>


                                                <LoginClass />

                                            </GridItem>
                                        </GridContainer>
                                    </form>
                                </Card>
                            </GridItem>
                        </GridContainer>
                    </div>
                </div>
            </div>
        );

    }
    else {
        return (<LoadingData text={"Authenticating User..."}/>)
    }


}
